import { useApi } from "hooks"
import { useMutation, useQueryClient } from "@tanstack/react-query";

/**
  realName: "string",
  birthDate: "2023-02-24T15:54:31.965Z",
  lang: "ha_ER",
  gender: 1,
  countryId: 0,
  bio: "string"
 */


const useUpdateProfile = () => {

  const { apiFetch } = useApi()
  const queryClient = useQueryClient()

  const url = `/me/profile`;
  const method = 'PATCH'


  const buyContent = (data) => {
    return apiFetch({
      url,
      method,
      data: {
        // realName: "string",
        // birthDate: "2023-02-24T15:54:31.965Z",
        lang: data.lang,
        // gender: 1,
        // countryId: 0,
        // bio: "string"
      }
    })
      .then(() => {
        queryClient.invalidateQueries('lang')
      })
  }

  const {
    mutateAsync,
    ...rest
  } = useMutation(buyContent)

  return {
    updateProfile: mutateAsync,
    ...rest,
  }
}

export default useUpdateProfile;